module.exports = __webpack_public_path__ + "img/tag2.dcdf3f8f.png";